import { LocationData } from "../Location/Entities";
import { ServiceResult } from "../../Services/ServiceEntities";
import { DateTime } from "luxon";
import { SectionDefinition } from "./ContactFormSections";
import { SubmitEnquiryResponse } from "../../Services/ContactUsContracts";

/** Form field of the contact form V2. */
export interface ContactFormFieldsV2 {
    bookingRef: string;
    cabNumber: string;
    custContactNumber: string;
    bookingContactNumber: string;
    emailAddress: string;
    firstName: string;
    itemDescription: string;
    lastName: string;
    pickupDateTime: DateTime;
    bookingName: string;
    driverId: string;
    selectedBookingHail: string;
    pickup: string;
    destination: string;
    isDatepickerInputFocused: boolean;
    dateArrowOnHover: boolean;
    timeArrowOnHover: boolean;
    shouldClearPickup: boolean;
    shouldClearDestination: boolean;
    isAndroidDatePickerOpen: boolean;
}

/** State of the contact form. */
export interface ContactFormStateV2 extends ContactFormFieldsV2 {
    isFormValid: boolean;
    displayPopup: string;
    invalidEmail: boolean;
    invalidPhone: boolean;
    invalidBookingPhone: boolean;
    message: { title: string; description: string; };
    invalidSection: boolean;
}

export interface ContactFormPropsV2 {

    /** Function to run on submit the form */
    onSubmit: (fields: ContactFormFieldsV2) => Promise<ServiceResult<SubmitEnquiryResponse | void>>;

    /** Category data */
    currentData: SectionDefinition;

    /** Section data */
    currentSection: number;

    /** User selected/IP location */
    locationData?: LocationData;

    /** Default fields which should be shown for any enquiry type */
    defaultFields?: Partial<ContactFormFieldsV2>;

    IsUserLoggedIn: boolean;
}

/** Categorisation of a Enquiry Type, to support searches for specific enquiries */
export enum EnquiryKind {
    PleaseSelect = 'PleaseSelect',
    Receipt = 'Receipt',
    Fare_Payment = 'Fare/Payment',
    LostProperty = 'LostProperty',
    AboutDriver = 'AboutDriver',
    GeneralEnquiry = 'GeneralEnquiry',
}

/** State of the Contact form component */
export interface ContactUsStateV2 {
    selectedSection: number;
}